var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AboutMenu',{attrs:{"menu":_vm.lang == 'zh' ? _vm.menu : _vm.enMenu}})}
var staticRenderFns = []

export { render, staticRenderFns }